import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListNumeric, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { SeguroInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import {
    ButtonEditar, ButtonRemover, ButtonTrash, ButtonVisualizar, JTable, JTBody, JTHead, SpanIcon
} from "../../../components/Components";
import { removeSeguro, removeSeguroTodos } from "../../../features/manifestoSlice";
import Averbacao from "./Averbacao";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import SeguroForm from "./SeguroForm";

export default function Seguro() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.seg);
    const { confirm, ConfirmModal } = useQuestion();
    const [showAverbacoes, setShowAberbacoes] = useState<boolean>(false);
    const [showFormSeguro, setShowFormSeguro] = useState<boolean>(false);
    const [idSeguro, setIdSeguro] = useState<number | string>(0);
    const [selecionado, setSelecionado] = useState<number | string>('');

    const handleAverbacaoClose = () => {
        setShowAberbacoes(false);
        setSelecionado('');
    }

    const handleCloseSeguroForm = () => {
        setShowFormSeguro(false);
        setSelecionado('');
        setIdSeguro(0);
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        let msg: React.ReactNode;

        const totalAver = lista.filter(f => f.id.toString() === value.id.toString()).flatMap(s => s.nAver).length;

        if (totalAver > 0) {
            msg = <>
                <div className=" fw-bold text-center bg-warning rounded-2 p-1">
                    Obs: Exite(m) avebação(ôes) vinculada(s) ao seguro.
                </div>
            </>
        }

        setSelecionado(value.id);
        const confirmed = await confirm({
            message: <> {msg}
                <div className={` ${totalAver > 0 ? 'mt-1 text-center' : ''}`}>
                    Deseja realmente remover <strong>{value.title}</strong> ?
                </div>
            </>,
            title: "Confirmação"
        });
        if (confirmed) {

            dispatch(removeSeguro(value.id));
        }
        setSelecionado('');
    }

    const handleEditSeguro = (id: number | string) => {
        setIdSeguro(id);
        setShowFormSeguro(true);
        setSelecionado(id);
    }

    const handleShowAberbacoes = (id: number | string) => {
        setIdSeguro(id);
        setShowAberbacoes(true)
        setSelecionado(id);
    }

    const removerTudo = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos os seguros ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeSeguroTodos());
            }
        }
    }

    return (<>

        <Button className="active me-2 mb-2" onClick={() => {
            setShowFormSeguro(true);
            setIdSeguro(0);
        }} title="Adicionar seguro"
        >
            <FontAwesomeIcon icon={faPlus} /> Adicionar
        </Button>

        <JTable responsive>
            <JTHead>
                <tr>
                    <th className="text-center" style={{ width: '4.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th>CPF/CNPJ</th>
                    <th>Número Apolice</th>
                    <th>Nome Seguradora</th>
                    <th>CNPJ Seguradora</th>
                    <th className="text-center" style={{ width: '7rem' }}>Averbações</th>
                </tr>
            </JTHead>
            <JTBody>
                {lista?.map((item: SeguroInterface) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center d-flex justify-content-around">
                            <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.nApol === '' ? item.cpfcnpj : item.nApol })} />
                            <ButtonEditar onClick={() => handleEditSeguro(item.id)} />
                        </td>
                        <td>{item.cpfcnpj}</td>
                        <td>{item.nApol}</td>
                        <td>{item.xSeg}</td>
                        <td>{item.cnpj}</td>
                        <td className="text-center">
                            <ButtonVisualizar icon={faListNumeric} onClick={() => handleShowAberbacoes(item.id)} title="Averbações" >
                                <SpanIcon count={item.nAver.length} />
                            </ButtonVisualizar>
                        </td>
                    </tr>
                ))}
            </JTBody>
        </JTable>

        {ConfirmModal}
        <Averbacao show={showAverbacoes} id={idSeguro} handleClose={handleAverbacaoClose} />
        <SeguroForm
            show={showFormSeguro}
            handleClose={handleCloseSeguroForm}
            id={idSeguro}
        />
    </>)
}